import CloseIcon from '@mui/icons-material/Close';

import { Grid, Button, Typography, useTheme, Box } from '@mui/material';
import StyledTextField from '@shared/components/StyledTextField';

import * as Yup from 'yup';
import { useFormik } from 'formik';

import { sendRegisterFormData } from '@shared/services/services';

import { sxHeader } from './styles';
import { CustomDialogModal } from '@shared/components/Dialogs';

const registerHotelFormSchema = Yup.object().shape({
  establishmentName: Yup.string().required('Campo requerido'),
  establishmentType: Yup.string().required('Campo requerido'),
  establishmentCategory: Yup.string().required('Campo requerido'),
  establishmentAddress: Yup.string().required('Campo requerido'),
  establishmentLocation: Yup.string().required('Campo requerido'),
  establishmentPhone: Yup.string()
    .required('Campo requerido')
    .matches('^[0-9]+$', 'Este campo solo acepta numeros'),
  establishmentWeb: Yup.string(),
  establishmentContactEmail: Yup.string()
    .required('Campo requerido')
    .email('Ingrese un email valido'),
  establishmentContactName: Yup.string().required('Campo requerido'),
});

const FormNewEstablishment = ({
  showModal,
  setShowModal,
  pageConfiguration,
  bspAndGitDollarValue,
  setIsRegisteredModal,
}) => {
  const theme = useTheme();

  const formik = useFormik({
    initialValues: {
      establishmentName: '',
      establishmentType: '',
      establishmentCategory: '',
      establishmentAddress: '',
      establishmentLocation: '',
      establishmentPhone: '',
      establishmentWeb: '',
      establishmentContactEmail: '',
      establishmentContactName: '',
    },
    validationSchema: registerHotelFormSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        <p
          style={{
            marginRight: '10px',
            color: '#000000DE',
            fontFamily: 'Open Sans, sans-serif',
            fontSize: '16px',
            fontWeight: 'normal',
          }}
        >
          Dolar GIT: ${bspAndGitDollarValue[0].money_value}
        </p>;
        await sendRegisterFormData({
          establishment_name: values.establishmentName,
          establishment_type: values.establishmentType,
          establishment_category: values.establishmentCategory,
          establishment_address: values.establishmentAddress,
          establishment_location: values.establishmentLocation,
          establishment_phone: values.establishmentPhone,
          establishment_web: values.establishmentWeb,
          establishment_contact_email: values.establishmentContactEmail,
          establishment_contact_name: values.establishmentContactName,
        });
        setIsRegisteredModal(true);
      } catch (error) {
        console.error('Error', error);
      } finally {
        resetForm();
        setShowModal(false);
      }
    },
  });

  return (
    <CustomDialogModal open={showModal} onClose={() => setShowModal(false)}>
      <Grid
        container
        direction="column"
        spacing={2}
        style={{ padding: '10px' }}
      >
        <Grid
          item
          xs={12}
          sx={{
            ...sxHeader.header,
            backgroundColor: theme.primary,
          }}
        >
          <Box
            component="img"
            src={pageConfiguration.site_logos.principal}
            alt={pageConfiguration.site_logos.alt}
            sx={sxHeader.logoStyle}
          />

          <Grid item xs={12}></Grid>
          <Grid
            item
            xs={6}
            style={{ position: 'absolute', display: 'contents' }}
          >
            <CloseIcon
              onClick={() => setShowModal(false)}
              fontSize="medium"
              style={{
                position: 'relative',
                color: '#ffffff',
                cursor: 'pointer',
              }}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ paddingLeft: '0px' }}>
          <Typography
            variant="h5"
            color="initial"
            align="left"
            style={{
              marginBottom: '20px',
              color: '#000000',
              marginTop: '15px',
              fontSize: '20px',
            }}
          >
            ¡Bienvenido a la plataforma de venta de alojamiento más exitosa de
            la región!
          </Typography>
        </Grid>
        <form onSubmit={formik.handleSubmit} autoComplete="off">
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ paddingBottom: '0px' }}>
              <Typography variant="body1" sx={sxHeader.textOnModal}>
                Datos del Establecimiento:
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} style={{ paddingBottom: '0px' }}>
              <StyledTextField
                label="Nombre del establecimiento"
                name="establishmentName"
                formik={formik}
              />
            </Grid>
            <Grid item xs={12} md={6} style={{ paddingBottom: '0px' }}>
              <StyledTextField
                label="Tipo de establecimiento"
                name="establishmentType"
                formik={formik}
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{ pb: '0px' }}>
              <StyledTextField
                formik={formik}
                textFieldSx={sxHeader.inputStyle}
                label="Categoría"
                name="establishmentCategory"
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{ pb: '0px' }}>
              <StyledTextField
                formik={formik}
                label="Dirección"
                name="establishmentAddress"
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{ pb: '0px' }}>
              <StyledTextField
                formik={formik}
                label="Localidad"
                name="establishmentLocation"
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{ pb: '0px' }}>
              <StyledTextField
                formik={formik}
                label="Teléfono"
                name="establishmentPhone"
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{ pb: '0px' }}>
              <StyledTextField
                formik={formik}
                label="Página web"
                name="establishmentWeb"
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{ pb: '0px' }}>
              <StyledTextField
                formik={formik}
                label="Dirección de correo"
                name="establishmentContactEmail"
              />
            </Grid>
            <Grid item xs={12} sx={{ pb: '0px' }}>
              <StyledTextField
                formik={formik}
                label="Nombre del responsable"
                name="establishmentContactName"
              />
            </Grid>
            <Grid
              container
              style={{
                margin: '20px auto',
                display: 'block',
                textAlign: 'end',
                paddingRight: '7px',
              }}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={() => setShowModal(false)}
                style={{
                  backgroundColor: '#7E7E7E',
                  borderRadius: '4px',
                  padding: '6px 24px',
                  marginRight: '20px',
                }}
              >
                Cerrar
              </Button>
              <Button
                color="primary"
                variant="contained"
                type="submit"
                style={{ borderRadius: '4px' }}
              >
                Registrar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </CustomDialogModal>
  );
};

export default FormNewEstablishment;
